var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"b2b-login__wrapper"},[[_c('div',{staticClass:"b2b-login__container"},[(_vm.loading)?_c('gl-loader'):_vm._e()],1),_c('div',{staticClass:"b2b-login__bottom"},[_vm._v(" SATOSHI EYE © "+_vm._s(_vm.getFullYear)+" ALL RIGHTS RESERVED ")])]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }